/* Program Name: LayoutAPI.js
 **  Description: controls all the functions that access the DAL API for layout
 **               related data.
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 ** ITSM735    2026-07-23  SS   Added Firehouse Subs (firehousesubs) theme
 ** SD9567     2026-07-29  sgs  ITSM-970 - Apply UI assets (colors, logos, fonts, etc) 
 **                             to FHS site
 *********************************************************************************/

import {
  culversStyle,
  bkStyle,
  thStyle,
  krystalStyle,
  devStyle,
  demoStyle,
  popeyesStyle,
  firehousesubsStyle,
} from './themes'

export const getTheme = (theme) => {
  switch (theme) {
    case 'culvers': {
      return culversStyle
    }
    case 'bk': {
      return bkStyle
    }
    case 'th': {
      return thStyle
    }
    case 'krystal': {
      return krystalStyle
    }
    case 'popeyes': {
      return popeyesStyle
    }
    case 'firehousesubs': {
      return firehousesubsStyle
    }
    case 'demo': {
      return demoStyle
    }
    case 'root': {
      return devStyle
    }
    default:
      return devStyle
  }
}
